import { Reveal, SectionHeading } from "./Reveal";

const steps = [
    { n: "01", title: "Create Phantom Wallet", desc: "Download Phantom or your favorite Solana wallet as an app or browser extension." },
    { n: "02", title: "Get Some SOL", desc: "Buy SOL on Coinbase, Binance or Kraken and send it to your Phantom wallet address." },
    { n: "03", title: "Connect to Raydium / Jupiter", desc: "Open Raydium or Jupiter, connect your wallet, and paste the official $POWEEN CA." },
    { n: "04", title: "Swap SOL for $POWEEN", desc: "Set slippage to 0.5–1%, enter your SOL amount, hit swap — welcome to the pack." },
];

export const HowToBuy = () => (
    <section id="how-to-buy" data-testid="how-to-buy-section" className="relative z-10 mx-auto max-w-7xl px-5 py-28">
        <SectionHeading overline="Your guide to joining the pumpkin pack" title="How To Buy $POWEEN" sub="Four steps between you and the moon" />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {steps.map((s, i) => (
                <Reveal key={s.n} delay={i * 0.12}>
                    <div
                        data-testid={`buy-step-${s.n}`}
                        className="group glass-panel relative h-full overflow-hidden rounded-3xl p-7 transition-[box-shadow,border-color,transform] duration-500 hover:-translate-y-1.5 hover:border-emerald-400/50 hover:shadow-[0_0_40px_rgba(0,255,135,0.15)]"
                    >
                        <span className="font-spooky absolute -top-3 right-3 text-7xl text-purple-500/15 transition-colors duration-500 group-hover:text-orange-500/20">
                            {s.n}
                        </span>
                        <p className="font-mono2 text-xs font-bold tracking-[0.3em] text-emerald-400">STEP {s.n}</p>
                        <h3 className="font-heading mt-4 text-base font-bold text-slate-100">{s.title}</h3>
                        <p className="mt-3 text-sm leading-relaxed text-slate-400">{s.desc}</p>
                    </div>
                </Reveal>
            ))}
        </div>
    </section>
);
